import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import EmptyComponent from "../../utils/EmptyComponent";
import CustomExistingTemplates from "./custom-template/CustomExistingTemplates";
import CustomTab from "./custom-template/CustomTab";
import Configuration from "./Configuration/Configuration";
import { HasScreenPermissions } from '../../utils/Token';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../commom/GlobalComponentProvider';
import PropTypes from 'prop-types';
import INFO from '../../pages/commom/RouteUrlInfo.json';

function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TemplatesAndSectionsTab({ tab }) {

  // const [value, setValue] = useState(tab === "Standard" ? 0 : tab == "VisitorManagement" ? 5 : 1);
  // useEffect(() => {
  //   setValue(tab === "Standard" ? 0 : tab == "VisitorManagement" ? 5 : 1);
  // }, [tab]);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();
  const [value, setValue] = useState(0); // Initialize with the default tab index
  const location = useLocation();



  useEffect(() => {
    setValue(currentActiveTab);
  }, [currentActiveTab, location]);

  const [MoveValue, setMOveValue] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // if (getOrgType() != "Admin") {
    //     setMOveValue(true);
    // }
  };

  return (
    <>
      <div style={{ minwidth: "100%", backgroundColor: "#F9FAFB" }}>
        <h1 className="mx-3 mt-3" style={{ color: "rgb(0,0,0)" }}>
          Questionnaire Tool
        </h1>
      </div>
      <Tabs value={value} onChange={handleChange} variant="scrollable" sx={{ marginLeft: 3 }}>
        <Tab label="Standard" {...a11yProps(0)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.TemplatesAndSections.actionName)} />
        <Tab label="Custom" {...a11yProps(1)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.CreateCustomTemplate.actionName)} />
        <Tab label="Questions Bank" {...a11yProps(2)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.QuestionsBank.actionName)} />
        <Tab label="Assign Templates" {...a11yProps(3)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.AssignedTemplatesList.actionName)} />
        <Tab label="Copy Information" {...a11yProps(4)} style={{ textTransform: "inherit" }} hidden={true} />{/*HasScreenPermissions(INFO?.CopyInformation.actionName) */}
        <Tab label="Template Mapping" {...a11yProps(5)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.QuizTemplatesAndSections.actionName)} />
        <Tab label="Create MoodleTemplate" {...a11yProps(6)} style={{ textTransform: "inherit" }} hidden={true} />{/*HasScreenPermissions(INFO?.CreateMoodleTemplate.actionName) */}
        <Tab label="Visitor Management" {...a11yProps(8)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.VisitorManagement.actionName)} />

      </Tabs>

      <TabPanel value={value} index={0}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CustomTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <Configuration />
      </TabPanel>

    </>
  );
}
